import { useTableLayoutClasses } from "../TableLayout.style";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import React from "react";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import { AppIconsClose, AppIconsInfo } from "../../../AppIcons";
import useBrands from "../../../../../explorer/hooks/useBrands";
import CommonDialog from "../../../CommonDialog/CommonDialog";

type TDeleteRowComponent = {
    item: any;
    additionalProps: any;
};

const DeleteRowComponent = (props: TDeleteRowComponent) => {
    const classes = useTableLayoutClasses();
    const [open, setOpen] = useState<boolean>(false);
    const { t } = useTranslation();

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDeleteRow = () => {
        setOpen(true);
        props.additionalProps.handleDeleteRow(props.item.rowId);
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Box
                key={props.item.code}
                sx={[classes.iconCell, classes.hideOnPrint]}
            >
                <Tooltip
                    title={t("common.basket.deleteRow")}
                    disableInteractive
                    placement="top"
                >
                    <IconButton
                        disabled={
                            props.additionalProps.loadingPrices ||
                            props.additionalProps.listDisabledRow.current.includes(
                                props.item.rowId
                            )
                        }
                        onClick={handleOpen}
                    >
                        <AppIconsClose />
                    </IconButton>
                </Tooltip>
            </Box>

            <CommonDialog
                open={open}
                dialogTitleLabel={"common.basket.confirmDeleteTitle"}
                dialogContentLabel={"common.basket.confirmDelete"}
                closeDialog={handleClose}
                confirmButton={handleDeleteRow}
            />
        </React.Fragment>
    );
};

export default DeleteRowComponent;
